export interface ResourceBundleConstant {
    cancel: string;
    noAccessText: string;
    soleOwner: string;
    moreThenTwoOwnwer: string;
    editorSelfRoleChange: string;
    maxOwnerLimit: string;
    minOwnerRequired: string;
    rolesDescriptionTitle: string;
    rolesDescriptionTooltip: string;
    roleOwner: string;
    roleEditor: string;
    roleCommenter: string;
    roleViewer: string;
    roleOwnerDescription: string;
    roleEditorDescription: string;
    roleCommenterDescription: string;
    roleViewerDescription: string;
    bold: string;
    italics: string;
    underline: string;
    strikethrough: string;
    insert: string;
    function: string;
    lambda: string;
    lambdaTitle: string;
    subscriptTitle: string;
    superscriptTitle: string;
    notEqualTitle: string;
    mathliveHelpText: string;
}

export const resourceBundleConstant: ResourceBundleConstant = {
    bold: 'B',
    italics: 'I',
    underline: 'U',
    strikethrough: 'S',
    cancel: 'Cancel',
    insert: 'Insert',
    function: 'ƒx',
    lambda: 'λ',
    lambdaTitle: 'Lambda',
    subscriptTitle: 'Subscript',
    superscriptTitle: 'Superscript',
    notEqualTitle: 'Not equal',
    mathliveHelpText:
        'Use toolbar/keyboard for fractions/roots/summations, or type LaTeX (e.g. ',
    noAccessText: "You don't have access to perform this action.",
    soleOwner: 'At least one owner is required for the project',
    moreThenTwoOwnwer: 'Maximum number of owners reached',
    editorSelfRoleChange: "As editor you can't relegate your own role.",
    maxOwnerLimit: 'The maximum number of owners has been reached. Contact admin to add more owners.',
    minOwnerRequired: 'Minimum one owner is required on the project. Please assign another owner before leaving the project or changing the role.',
    rolesDescriptionTitle: 'Roles Description',
    rolesDescriptionTooltip: 'Roles Description',
    roleOwner: 'Owner',
    roleEditor: 'Editor',
    roleCommenter: 'Commenter',
    roleViewer: 'Viewer',
    roleOwnerDescription: 'You can add owners up to the project configured limit. You can invite additional collaborators (editors, commenters, viewers), you can delete collaborators. You can make changes to the project, and add comments.',
    roleEditorDescription: 'You can invite additional collaborators (editors, commenters, viewers), you can delete collaborators. You can make changes to the project, and add comments.',
    roleCommenterDescription: 'You can add comments, but you cannot make changes.',
    roleViewerDescription: 'You can view project, but you cannot make changes or add comments.',
};
